export const BACKEND_URL = process.env.REACT_APP_BASE_URL;
export const API_URL = `${BACKEND_URL}/api/v1`;
export const DEFAULT_PAGE = process.env.REACT_APP_DEFAULT_PAGE || "/auth/login";
export const AIRLINE_COUNTRY_CODE = process.env.REACT_APP_AIRLINE_COUNTRY_CODE || "VN";
export const LICENSE_KEY = process.env.REACT_APP_LICENSE_KEY;
export const NAV_HEIGHT = '3.3rem';
export const HEADER_HEIGHT = '3.3rem';
export const GAP_HEIGHT = '3rem';
export const LAYOUT_HEIGHT = `calc(100vh - ${NAV_HEIGHT} - ${HEADER_HEIGHT} - ${GAP_HEIGHT})`;
export const DASHBOARD_TIMER_INTERVAL = 1800000; //30 MINUTES
export const TIMEZONE_OFFSET_MINUTES = 420; // 7 HOURS
export const TIMEZONE = 'Asia/Ho_Chi_Minh';
export const OTP_DELAY_MINUTES = 15;
export const OTP_EARLY_MINUTES = 5;
export const MINIMUM_TAT_MINUTES = 20;
export const MAXIMUM_TAT_MINUTES = 180;
export const REPORTING_MINUTES = 60;
export const INT_REPORTING_MINUTES = 75;
export const DOM_REPORTING_MINUTES = 60;
export const DEBRIEFING_MINUTES = 15;
export const FLIGHT_DATES = [
  'flightDate', 
  'flightDateLocalBase', 
  'flightActualDayDep', 
  'flightActualDayDep',
];
export const EXCLUDED_FLIGHT_STATUS = ['Cancelled', 'Deleted'];
export const DIVERT_RETURN_STATUS = ['Diverted', 'Forced Return (Air)', 'Forced Return (Ramp)'];
export const SERVICE_TYPE_EXCLUDE = ['Training', 'Technical Test', 'Cargo', 'Mail', 'Military'];
export const PICK_UP_MINUTES = [
  { type: 'Domestic',
    values: { 
      "SGN": 90, 
      "HAN": 110, 
      "DAD": 0, 
      "CXR": 0, 
      "OTHER": 90, 
    }
  }, 
  { type: 'International',
    values: { 
      "SGN": 105, 
      "HAN": 120, 
      "DAD": 0, 
      "CXR": 0, 
      "OTHER": 105, 
    }
  }
];
export const TRAVEL_MINUTES = {
  "SGN": 15,
  "HAN": 40,
  "DAD": 0,
  "CXR": 0
};


export const DEFAULT_PIT_CONFIG = {
  validSince: '2026-01-01',
  validUntil: null,
  personalDeduction:  15500000,   
  dependentDeduction: 6200000,    
  brackets: [
    { max: 10000000,  rate: 0.05,  deduction: 0        },
    { max: 30000000,  rate: 0.10, deduction: 500000   },
    { max: 60000000,  rate: 0.20, deduction: 3500000  },
    { max: 100000000, rate: 0.30, deduction: 9500000  },
    { max: null,      rate: 0.35, deduction: 14500000 },
  ],
  rules: [
    { limit: 79500000, subtract: 14500000, rate: 0.65 },
    { limit: 51500000, subtract: 9500000,  rate: 0.70 },
    { limit: 27500000, subtract: 3500000,  rate: 0.80 },
    { limit: 9500000,  subtract: 500000,   rate: 0.90 },
    { limit: 0,        subtract: 0,        rate: 0.95 },
  ],
};